module.exports = __webpack_public_path__ + "img/icon-unionpay.14c27198.svg";